import { useUserStore } from '@/store/useUserStore';

export default async (error: any) => {
	const { response } = error;

	switch (response?.status) {
		case 401: {
			const userStore = useUserStore();
			await userStore.logout(true);
			break;
		}

		default:
			break;
	}

	throw error;
};
